import React from 'react';

const CoverageSVG = ({ color, width, height }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width ? width : '24'}
    height={height ? height : '24'}
    viewBox="0 0 24 24"
  >
    <path
      fill={color ? color : '#ffffff'}
      fillRule="evenodd"
      d="M12.3759145,18.0005865 L12.3759145,5.90565674 L6.79333878,8.23010221 C7.12149579,12.7696075 9.34046222,16.1449367 12.3759145,18.0005865 Z M20.5993729,5.26887588 L13.0986413,2.14357105 L13.0986412,2.14357103 C12.63719,1.95214298 12.1185457,1.95214298 11.6570944,2.14357106 L4.15636279,5.2688759 C3.45707583,5.55796659 3,6.24162703 3,6.99951345 C3,14.7541761 7.47309255,20.1140739 11.6531878,21.8564313 C12.1141702,22.0478562 12.6337522,22.0478562 13.0947346,21.8564313 C16.4427174,20.461764 21.751829,15.6448879 21.751829,6.99951345 C21.751829,6.24162703 21.2947532,5.55796659 20.5993729,5.2688759 L20.5993729,5.26887588 Z M12.3759145,20.1257937 C8.56694927,18.5397015 4.87518294,13.6134398 4.87518294,6.99951343 L12.3759145,3.8742086 L19.8766461,6.99951343 C19.8766461,13.7892382 16.0325212,18.6022076 12.3759145,20.1257937 Z"
      transform="translate(-3 -2)"
    />
  </svg>
);

export default CoverageSVG;
